'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedHTMLMessage';
import { Big } from 'foundations-components/transitional/components/Big';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const translateEmptyStateMessage = contentType => {
  return {
    subText: `salesContentIndexUI.emptyState.search.${contentType}.subText`,
    titleText: `salesContentIndexUI.emptyState.search.${contentType}.titleText`
  };
};
const EmptyStateMessage = ({
  illustrationWidth = 200,
  reversed = false,
  secondaryContentWidth = 200,
  children,
  contentType
}) => {
  const {
    subText,
    titleText
  } = translateEmptyStateMessage(contentType);
  const secondaryContent = /*#__PURE__*/_jsx(Illustration, {
    name: "empty-state-charts",
    width: illustrationWidth
  });
  const primaryContent = /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(Big, {
      tagName: "p",
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: subText
      })
    }), children]
  });
  const emptyState = /*#__PURE__*/_jsx(EmptyState, {
    flush: true,
    primaryContent: primaryContent,
    reverseOrder: reversed,
    secondaryContent: secondaryContent,
    secondaryContentWidth: secondaryContentWidth,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: titleText
    })
  });
  return /*#__PURE__*/_jsx(Section, {
    marginBlock: 1000,
    "data-selenium-test": "EmptyStateMessage",
    children: /*#__PURE__*/_jsx(View, {
      marginInline: "auto",
      as: "div",
      children: emptyState
    })
  });
};
EmptyStateMessage.propTypes = {
  children: PropTypes.node,
  illustrationWidth: PropTypes.number,
  reversed: PropTypes.bool,
  secondaryContentWidth: PropTypes.number,
  contentType: PropTypes.string.isRequired
};
export default EmptyStateMessage;